module.exports = __webpack_public_path__ + "media/trumpet.de7c0cf3.mp3";